import { render, staticRenderFns } from "./EstAnswer.vue?vue&type=template&id=1b04b377&scoped=true&"
import script from "./EstAnswer.vue?vue&type=script&lang=js&"
export * from "./EstAnswer.vue?vue&type=script&lang=js&"
import style0 from "./EstAnswer.vue?vue&type=style&index=0&id=1b04b377&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b04b377",
  null
  
)

export default component.exports